//----------------------------------
// Private Constants
//----------------------------------
import i18n from '@/i18n';

const LOCALE_FIXED = 'de-ch';
const DATETIME_FORMAT_NUMERIC = 'numeric'; // e.g. 1979
const DATETIME_FORMAT_TWO_DIGIT = '2-digit'; // e.g. 79

//----------------------------------
// Internal Methods
//----------------------------------
const internal = {
  dateTimeFormatter: new Intl.DateTimeFormat(LOCALE_FIXED, {
    year: DATETIME_FORMAT_NUMERIC,
    month: DATETIME_FORMAT_TWO_DIGIT,
    day: DATETIME_FORMAT_TWO_DIGIT,
    hour: DATETIME_FORMAT_TWO_DIGIT,
    minute: DATETIME_FORMAT_TWO_DIGIT,
  }),
  dateFormatter: new Intl.DateTimeFormat(LOCALE_FIXED, {
    year: DATETIME_FORMAT_NUMERIC,
    month: DATETIME_FORMAT_TWO_DIGIT,
    day: DATETIME_FORMAT_TWO_DIGIT,
  }),
  timeFormatter: new Intl.DateTimeFormat(LOCALE_FIXED, {
    hour: DATETIME_FORMAT_TWO_DIGIT,
    minute: DATETIME_FORMAT_TWO_DIGIT,
  }),
};

//---------------------------------------------------
//
//  Exported Class
//
//---------------------------------------------------
export default class Format {
  static toString(value) {
    return value ? `${value}` : '';
  }

  static arrayCount(value) {
    return value && value.constructor === Array ? value.length : 0;
  }

  static toLocalizedDateTime(value) {
    if (value) {
      const date = Date.parse(value);
      return internal.dateTimeFormatter.format(date);
    }
    return value;
  }

  static toLocalizedDate(value) {
    if (value) {
      const date = Date.parse(value);
      return internal.dateFormatter.format(date);
    }
    return value;
  }

  static toLocalizedTime(value) {
    if (value) {
      const date = Date.parse(value);
      return internal.timeFormatter.format(date);
    }
    return value;
  }

  static toLocalizedRelativeDays(value, maxDays = Infinity) {
    if (value && Intl.RelativeTimeFormat) {
      const rf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
      const date = (new Date(value)).setHours(0, 0, 0, 0);
      const today = (new Date()).setHours(0, 0, 0, 0);
      const days = Math.round((date - today) / (1000 * 60 * 60 * 24));
      if (days > -maxDays) {
        return rf.format(days, 'day');
      }
    }
    return Format.toLocalizedDate(value);
  }

  static toI18nRole(value) {
    return i18n.t(`roles.${value}`);
  }
}
